export const API_PARAM = {
  //DOMAINS
  DOMAINS: "launchpad/domains",
  DOMAIN_SKILL_PATHS: "launchpad/domains/{id}/skill-paths",
  NEXT_DOMAIN_COURSE: "launchpad/domains/{id}/contents/next",
  DOMAIN_ENROLLMENT: "launchpad/domains/{id}/enroll",
  DOMAIN_COURSES: "launchpad/domains/{id}/contents",
  USERS_JOB_COURSES: "launchpad/domains/job-role/contents",
  USERS_JOB_RECOMMENDED_SKILL_PATHS: "launchpad/domains/job-role/recommended-skill-paths",
  USERS_DOMAIN_RECOMMENDED_SKILL_PATHS: "launchpad/domains/{id}/recommended-skill-paths",
  RELATED_JOBS: "launchpad/domains/{id}/related-job-domains",
  JOBS_USING_SKILL: "launchpad/domains/{id}/jobs-using-skill",
  //HEROES
  HEROES: "launchpad/heroes",
  //COURSES
  SKILL_PATH_COURSES: "launchpad/skill-paths/{id}/contents",
  COURSE_STATUS: "launchpad/contents/status",
  COURSES_IN_PROGRESS: "launchpad/contents/in-progress",
  COURSE: "launchpad/contents/{id}",
  PLAYER_TOKEN: "/launchpad/player/token",
  //SKILL_PATH_LEVELS
  SKILL_PATH_LEVELS: "launchpad/skill-path-levels",
  //SKILL_PATH
  SKILL_PATH_DETAILS: "launchpad/skill-paths/{id}",
  SKILL_PATH_CONTENTS: "launchpad/skill-paths/{id}/contents",
  SKILL_PATH_SKILLS: "launchpad/skill-paths/{id}/skills",
  SKILL_PATH_GOALS: "launchpad/skill-paths/{id}/goals",
  SKILLPATHS_IN_PROGRESS: "launchpad/skill-paths/in-progress",
  //SKILL_PATH_BADGE_DONWLOAD_CERTIFICATE
  SKILL_PATH_CERTIFICATE: "launchpad/badges/{id}/export",
  //SKILL_PATH_BADGE_LINKEDIN_SHARE
  SKILL_PATH_SHARE_URL: "launchpad/badges/{id}/share",

  //LINKEDIN_SHARE
  LINKEDIN_SHARE_URL: "https://www.linkedin.com/sharing/share-offsite/?url=",
  SHARE_BADGE_URL: "/shared/badge/",
  //USER_RATING
  USER_RATING: "launchpad/user-ratings",
  //CONTENT_TRACKING
  COURSE_TRACK: "launchpad/contents/track",
  //USER PROFILE DIALOGS
  JOBS_DETAILS: "launchpad/user-profile-verification/job-details/{id}",
  SKILL_DETAILS: "launchpad/user-profile-verification/skill-details/{id}",
  //USER PROFILE STEPS
  USER_JOB_ROLE: "launchpad/user-profile-verification/job-role",
  USER_SKILLS: "launchpad/user-profile-verification/skills",
  USER_JOB_GOALS: "launchpad/user-profile-verification/job-goals",
  USER_SKILL_GOALS: "launchpad/user-profile-verification/skill-goals",
  AVAILABLE_JOB_ROLES:
    "launchpad/user-profile-verification/available-jobs/grid",
  AVAILABLE_JOB_VALUES:
    "launchpad/user-profile-verification/available-jobs/grid/values",
  AVAILABLE_SKILLS: "launchpad/user-profile-verification/available-skills/grid",
  AVAILABLE_SKILL_VALUES:
    "launchpad/user-profile-verification/available-skills/grid/values",
  AVAILABLE_JOB_GOALS:
    "launchpad/user-profile-verification/available-job-goals/grid",
  AVAILABLE_JOB_GOAL_VALUES:
    "launchpad/user-profile-verification/available-job-goals/grid/values",
  AVAILABLE_SKILL_GOALS:
    "launchpad/user-profile-verification/available-skill-goals/grid",
  AVAILABLE_SKILL_GOAL_VALUES:
    "launchpad/user-profile-verification/available-skill-goals/grid/values",
  //SAVE PROFILE STEP
  SAVE_STEP: "launchpad/user-profile-verification",
  //ADD REMOVE SKILL & JOB GOALS
  ADD_SKILL_GOAL: "launchpad/user-profile-verification/{id}/skill-goals/add",
  ADD_JOB_GOAL: "launchpad/user-profile-verification/{id}/job-goals/add",
  REMOVE_SKILL_GOAL:
    "launchpad/user-profile-verification/{id}/skill-goals/remove",
  REMOVE_JOB_GOAL: "launchpad/user-profile-verification/{id}/job-goals/remove",
  //DASHBOARD
  DASHBOARD_MY_SKILLS: "launchpad/dashboard/my-skills",
  DASHBOARD_JOBS_OF_INTEREST: "launchpad/dashboard/jobs-of-interest",
  DASHBOARD_TIME_INVESTMENT: "launchpad/dashboard/time-investment",
};
